import { createSvgIcon, Stack, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import React from 'react';

function LeaderboardRow(props) {
    const theme = useTheme();

    const percentageColor = props.value >= 0.85 ? theme.palette.green.leaderboard : theme.palette.red.leaderboard;
    const isCurrentUser = props.physician.id === props.currentUser.id;
    const shouldShowPercentileChip = isCurrentUser && props.userPercentile;

    function ordinalSuffixOf(i) {
        let j = i % 10,
            k = i % 100;
        if (j === 1 && k !== 11) {
            return i + 'st';
        }
        if (j === 2 && k !== 12) {
            return i + 'nd';
        }
        if (j === 3 && k !== 13) {
            return i + 'rd';
        }
        return i + 'th';
    }

    return (
        <Stack p={1} direction='row' alignItems='center' justifyContent='space-between' sx={{ fontSize: '14px', border: isCurrentUser ? `1px solid ${theme.palette.blue.border}` : '', borderRadius: '4px' }}>
            <Stack direction='row' alignItems='center' spacing={2} maxWidth={shouldShowPercentileChip ? '45%' : '100%'}>
                { props.ranking === 1 ? 
                    <CrownIcon /> : 
                    <Box width='24px' display='grid' justifyItems='center' >
                        <Typography variant='heavy'>
                            {props.ranking}
                        </Typography>
                    </Box>
                }
                <Typography variant='heavy'>
                    {props.physician.first_name + ' ' + props.physician.last_name}
                </Typography>
            </Stack>
            <Stack direction='row' spacing={0.5} alignItems='center'>
                { shouldShowPercentileChip &&
                    <Box p={0.5} sx={{ borderRadius: '4px', backgroundColor: props.userPercentile >= 0.75 ? `${theme.palette.itemSwapChip.background.positive}` : `${theme.palette.itemSwapChip.background.negative}` }}>
                        <Typography variant='heavy' sx={{ fontSize: '12px', color: props.userPercentile >= 0.75 ? `${theme.palette.green.leaderboard}` : `${theme.palette.red.leaderboard}` }}>
                            {ordinalSuffixOf(Math.round(props.userPercentile * 100))} Percentile
                        </Typography>
                    </Box>
                }
                <Typography variant='heavy' color={percentageColor} sx={{ opacity: '1.0' }}>
                    {Math.round(props.value * 100)}%
                </Typography>
            </Stack>
        </Stack>
    );
}

const CrownIcon = createSvgIcon(
    <path id="Path_2915" data-name="Path 2915" d="M4.467-5.188a2.362,2.362,0,0,0,1.242-.336,2.552,2.552,0,0,0,.891-.9,2.387,2.387,0,0,0,.332-1.244A2.349,2.349,0,0,0,6.6-8.887a2.557,2.557,0,0,0-.891-.9,2.36,2.36,0,0,0-1.242-.337,2.393,2.393,0,0,0-1.238.332,2.508,2.508,0,0,0-.9.891A2.366,2.366,0,0,0,2-7.663,2.363,2.363,0,0,0,2.337-6.42a2.589,2.589,0,0,0,.9.9A2.348,2.348,0,0,0,4.467-5.188Zm0-1.533A.891.891,0,0,1,3.808-7a.913.913,0,0,1-.274-.664.882.882,0,0,1,.274-.653.9.9,0,0,1,.658-.269.9.9,0,0,1,.658.274.887.887,0,0,1,.273.649A.922.922,0,0,1,5.129-7,.885.885,0,0,1,4.467-6.721Zm9.512-2.325a2.346,2.346,0,0,0,1.234-.336,2.552,2.552,0,0,0,.891-.9,2.386,2.386,0,0,0,.332-1.243,2.351,2.351,0,0,0-.332-1.225,2.557,2.557,0,0,0-.891-.9,2.344,2.344,0,0,0-1.234-.337,2.386,2.386,0,0,0-1.243.332,2.556,2.556,0,0,0-.9.891,2.343,2.343,0,0,0-.337,1.234,2.362,2.362,0,0,0,.337,1.243,2.588,2.588,0,0,0,.9.9A2.365,2.365,0,0,0,13.979-9.047Zm0-1.533a.9.9,0,0,1-.663-.278.9.9,0,0,1-.278-.663.876.876,0,0,1,.278-.654.92.92,0,0,1,.663-.269.886.886,0,0,1,.649.274.888.888,0,0,1,.273.649.921.921,0,0,1-.269.663A.875.875,0,0,1,13.979-10.58Zm9.494,5.391a2.363,2.363,0,0,0,1.242-.336,2.588,2.588,0,0,0,.9-.9,2.363,2.363,0,0,0,.337-1.244A2.342,2.342,0,0,0,25.611-8.9a2.556,2.556,0,0,0-.9-.891,2.384,2.384,0,0,0-1.242-.332,2.346,2.346,0,0,0-1.234.337,2.556,2.556,0,0,0-.891.9,2.349,2.349,0,0,0-.332,1.224,2.387,2.387,0,0,0,.332,1.244,2.551,2.551,0,0,0,.891.9A2.348,2.348,0,0,0,23.473-5.188Zm0-1.533A.876.876,0,0,1,22.819-7a.922.922,0,0,1-.269-.664.887.887,0,0,1,.274-.649.887.887,0,0,1,.649-.274.919.919,0,0,1,.662.269.875.875,0,0,1,.278.653A.906.906,0,0,1,24.135-7,.9.9,0,0,1,23.473-6.721ZM5.534-5.8,8.5-4a1.819,1.819,0,0,0,1.157.235,1.587,1.587,0,0,0,1.136-.7L14.316-9.2l-1.457-.627L9.674-5.53a.468.468,0,0,1-.259.189.509.509,0,0,1-.36-.106L6.346-7.122Zm16.888,0L21.61-7.119,18.918-5.463a.539.539,0,0,1-.381.115.447.447,0,0,1-.273-.216L15.1-9.822,13.64-9.2l3.542,4.753a1.535,1.535,0,0,0,1.11.69A1.77,1.77,0,0,0,19.4-3.962ZM6.711,3.34H21.238V1.8H6.711ZM4.377-5.594,6.272,4.656a3.13,3.13,0,0,0,.911,1.672,2.654,2.654,0,0,0,1.8.56h9.975a2.654,2.654,0,0,0,1.8-.56,3.134,3.134,0,0,0,.912-1.672l1.894-10.25-1.436-.648L20.147,4.445a1.088,1.088,0,0,1-1.175.9H8.977a1.088,1.088,0,0,1-1.175-.9L5.812-6.243Z" transform="translate(-2 13.977)" fill="#d3a731"/>,
    'Crown'
);

export default LeaderboardRow;
